function buildEventonFeed(category, categoryType, showFeature) {
    var feedUrl = "https://events.flinders.edu.au";
    var parametersUrl = "?json=get_posts&post_type=ajde_events&orderby=meta_value&meta_key=evcal_srow&order=asc&count=3";
    var showFeatureImage = showFeature;
    var eventList = $('#eventsList');
    
    // Is the event category set in the dialogue. 
    if (category !== "") {
        // Set the URL to include the categoryType slug and category slug. categoryType is the eventon plugin slug (examples: event-type, event-type-2 etc) category slug (examples: feature, student-event, alumni-development, etc)
        feedUrl =  feedUrl + "/" + categoryType + "/" + category + '/';
        var categorySlug = "#" + category;
        eventList = $(categorySlug);
    }

    //Set the feed URL
    feedUrl = feedUrl + parametersUrl;

    

    //if events exist
    if (eventList.length) {
        $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var events = data.posts;
            var eventTemplate = $('#event').text();
            var compiledEventTemplate = doT.template(eventTemplate);
            var dataToProvide;
            for (var i = 0; i < data.count; i++) {
                dataToProvide = events[i];
                dataToProvide.eventUrl = dataToProvide.url;
                dataToProvide.date = new Date(moment.unix(dataToProvide.custom_fields.evcal_srow));
                dataToProvide.date_day = moment.utc(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment.utc(dataToProvide.date).format('MMM');
                dataToProvide.date_time = moment.utc(dataToProvide.date).format('h:mm a');
                dataToProvide.location = dataToProvide.taxonomy_event_location[0].title;
                dataToProvide.bg_Color = dataToProvide.custom_fields.evcal_event_color;
                
                //Does the event have a feature image and is the show feature dialogue checked.
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay = 'events_overlay';
                   dataToProvide.buttonStyle = 'classic_transparent_button_white_border__small';
                }
                else {
                    dataToProvide.bgImage = '';
                    dataToProvide.overlay = '';
                    dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';
                    
                }

                eventList.append(compiledEventTemplate(dataToProvide));
            }
        });
    }
}

